import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState } from '@y42/angular/util';
import { map } from 'rxjs';
import { OrchestrationDiagramService } from '../services/orchestration-diagram.service';
import { OrchestrationDiagramToolbarService } from './orchestration-diagram-toolbar.service';

@UntilDestroy()
@Component({
  selector: 'y42-orchestration-diagram-toolbar',
  templateUrl: './orchestration-diagram-toolbar.component.html',
  styleUrls: ['./orchestration-diagram-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrchestrationDiagramToolbarComponent {
  constructor(
    private readonly orchestrationDiagramService: OrchestrationDiagramService,
    private readonly orchestrationDiagramToolbarService: OrchestrationDiagramToolbarService,
  ) {}

  private readonly undoManagerStats$ = this.orchestrationDiagramService.undoMangerStats$;
  private readonly activeNode$ = this.orchestrationDiagramService.activeNode$;
  private readonly isDiagramEditable$ = this.orchestrationDiagramService.isEditable$;
  private readonly outputMode$ = this.orchestrationDiagramService.outputModel$;

  get diagram() {
    return this.orchestrationDiagramService.diagram;
  }

  readonly state = connectState(this, {
    isDiagramEditable: this.isDiagramEditable$,
    isUndoButtonDisabled: this.activeNode$.pipe(map((activeNode) => !!activeNode)),
    undoCount: this.undoManagerStats$.pipe(map((stats) => stats.undoCount)),
    canUndo: this.undoManagerStats$.pipe(map((stats) => stats.canUndo)),

    isRedoButtonDisabled: this.activeNode$.pipe(map((activeNode) => !!activeNode)),
    redoCount: this.undoManagerStats$.pipe(map((stats) => stats.redoCount)),
    canRedo: this.undoManagerStats$.pipe(map((stats) => stats.canRedo)),

    diagramHasValidNodes: this.outputMode$.pipe(map((model) => model.nodeDataArray.length > 0)),
    importLoader: this.orchestrationDiagramToolbarService.importLoader$,
    exportLoader: this.orchestrationDiagramToolbarService.exportLoader$,
  });

  alignNodes() {
    this.orchestrationDiagramToolbarService.alignNodes();
  }

  undo() {
    this.orchestrationDiagramToolbarService.undo();
  }

  redo() {
    this.orchestrationDiagramToolbarService.redo();
  }

  searchOrchestrationNodes() {
    this.orchestrationDiagramToolbarService.searchOrchestrationNodes();
  }

  addNodesToOrchestration() {
    this.orchestrationDiagramToolbarService.addOrchestrationNodes();
  }

  importJson(event: Event) {
    this.orchestrationDiagramToolbarService.importJson(event);
  }

  exportJson(downloadLink: HTMLAnchorElement) {
    this.orchestrationDiagramToolbarService.exportJson(downloadLink);
  }
}
